import { TMainPageLayoutV3 } from "../type";
import LanguageVersionSelector from "@/utilities/LanguageVersionSelector";
import TLanguageVersionList from "@/cms/types/TLanguageVersionList";
import EView from "@/cms/enums/EView";
import EViewType from "@/cms/enums/EViewType";
import EContentType from "@/cms/enums/EContentType";
import { isEmpty, orderBy } from "lodash";
import RMDRComponentSanitizer from "@/components/RMDRComponentSanitizer";
import { metaDataLanguageVersion, outerNameDescriptionLanguageVersion } from "@/utilities/LanguageVersionSelectorShortcut";
import RMDRSocialShare from "@/components/RMDRSocialShare";
import { useOutletContext } from "react-router-dom";
import TOutletContext from "@/cms/types/TOutletContext";


const MNPG043 = ( props: TMainPageLayoutV3 ) => {
    console.log("MNPG043.rendered: ", props);

    const { siteSettingPayload } = useOutletContext<TOutletContext>();

    if ( !props.template || !props.params?.["contentDetails"] || isEmpty(props.params?.["contentDetails"]) ) return null;

    const languageVersion = outerNameDescriptionLanguageVersion(props.params["contentDetails"]?.languageVersions);

    const titleString = metaDataLanguageVersion("titleString", props.template.languageVersions);
    const shareString = metaDataLanguageVersion("shareString", siteSettingPayload.languageVersions);

    const languageVersions = orderBy(LanguageVersionSelector<TLanguageVersionList[]|undefined>({
        languageVersions: props.params["contentDetails"]?.languageVersions,
        filters: [
            { view: EView.INNER, viewType: EViewType.TEXT, contentType: EContentType.PAGE }
        ],
        type: "filter"
    }), ["order"],["asc"]);

    return (
        <div className="details-list-area">
            <h3>{titleString}</h3>
            <ul className="details-list">
                {
                    languageVersions?.map((item) => {

                        return(
                            <RMDRComponentSanitizer 
                                key={item.id}
                                languageVersion={item}
                                valueExpr="value"
                                variant="li"
                                removeTag
                            />
                        )
                    })
                }
            </ul>
            <div className="social-icon d-flex align-items-center">
                <span>{shareString} </span>
                <RMDRSocialShare 
                    contentRouteNavigationURL={window.location.href}
                    title={languageVersion?.name}
                />
            </div>
        </div>
    )
}

export default MNPG043;
